import api from './api';

// Détection des numéros DOM-TOM FIXES (Guadeloupe, Martinique, Guyane).
// DOIT rester aligné avec backend/src/services/sms.js — source de vérité métier.
// Si tu modifies l'une, modifie l'autre.
//
// Règle : on bloque uniquement les FIXES (0590/0596/0594 en local et leurs
// équivalents internationaux +590590…, +596596…, +594594…). Les mobiles DOM-TOM
// 0690/0696/0694 et leurs équivalents internationaux +590690…, +596696…,
// +594694… sont AUTORISÉS.
//
// Exemples :
//   0590123456     → bloqué (fixe Guadeloupe)
//   0690123456     → autorisé (mobile Guadeloupe)
//   +590690123456  → autorisé (mobile Guadeloupe international)
//   +590590123456  → bloqué  (fixe Guadeloupe international)
//   0612345678     → autorisé (mobile métropole)
export function isFixedDomTomNumber(rawPhone) {
  if (!rawPhone) return false;
  let cleaned = String(rawPhone).replace(/[\s\-.()]/g, '');
  if (!cleaned) return false;
  if (cleaned.startsWith('00')) cleaned = '+' + cleaned.slice(2);
  const FIXE_LOCAL = /^0(590|596|594)\d{6}$/;
  const FIXE_INTL  = /^\+(590|596|594)(590|596|594)\d{6}$/;
  return FIXE_LOCAL.test(cleaned) || FIXE_INTL.test(cleaned);
}

// Le numéro peut-il RECEVOIR un SMS ?
//
// DOIT rester aligné sur `normaliserNumeroMobile` de backend/src/services/sms.js,
// qui est la source de vérité : c'est lui qui refuse l'envoi. Ici on ne fait que
// l'anticiper, pour ne pas proposer un envoi que le serveur rejettera.
//
// Règle : 10 chiffres commençant par 0, puis 06 ou 07. Elle couvre la métropole
// (06/07) comme l'outre-mer, dont tous les mobiles commencent par 06 — 0690/0691
// Guadeloupe, 0696/0697 Martinique, 0694 Guyane, 0692/0693 Réunion. Les formes
// internationales (+590…, +596…, +594…, +33…) et le préfixe 00 sont ramenés au
// format local avant le test, exactement comme côté serveur.
//
// ⚠️ Ceci REMPLACE `isFixedDomTomNumber` pour décider d'une PROPOSITION : cette
// dernière ne bloque que les fixes DOM-TOM et laissait donc passer les numéros
// tronqués ou vides. Mesuré en production : 141 dossiers sur 60 jours (1,9 %)
// dont le numéro compte 0, 4 ou 12 chiffres — autant de propositions qui ne
// pouvaient qu'échouer à l'envoi.
export function estMobileEnvoyable(rawPhone) {
  let n = String(rawPhone || '').replace(/[\s\-.()]/g, '');
  if (!n) return false;
  if (n.startsWith('00')) n = '+' + n.slice(2);
  let m = n.match(/^\+(590|596|594)(\d{9})$/);
  if (m) n = '0' + m[2];
  m = n.match(/^\+33([1-9]\d{8})$/);
  if (m) n = '0' + m[1];
  if (/^[67]\d{8}$/.test(n)) n = '0' + n;
  return /^0[67]\d{8}$/.test(n);
}

export const sms = {
  // Config SMS de toutes les concessions (super-admin)
  getConfig: () => api.get('/sms/config'),

  // Modifier config SMS d'une concession (super-admin)
  updateConfig: (concessionId, data) => api.put(`/sms/config/${concessionId}`, data),

  // Envoyer un SMS
  send: (data) => api.post('/sms/send', data),

  // Historique SMS d'une demande
  getHistory: (demandeId) => api.get(`/sms/history/${demandeId}`),
};

export default sms;
